import React from 'react';
import { cx } from '../cx';

// D-09 §15.33 — Item List
// (.item-list > .item-list-row{.item-list-title · hint(StatusHint) · .item-list-link · trailing})
// 작업 내역 등 행 단위 목록. 리스트(§15.28) 특화형.

export type ItemListProps = React.HTMLAttributes<HTMLUListElement>;

export function ItemList({ className = '', children, ...props }: ItemListProps) {
  return (
    <ul className={cx('item-list', className)} {...props}>
      {children}
    </ul>
  );
}

export interface ItemListRowProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'title'> {
  title: React.ReactNode;
  /** 위치 등 안내 — StatusHint 권장 (선택) */
  hint?: React.ReactNode;
  /** 활동/이동 링크 텍스트 (선택) */
  link?: React.ReactNode;
  /** 트레일링 슬롯 — 상태 뱃지(Badge) 등 (선택) */
  trailing?: React.ReactNode;
}

export function ItemListRow({ title, hint, link, trailing, className = '', ...props }: ItemListRowProps) {
  return (
    <li>
      <button type="button" className={cx('item-list-row', className)} {...props}>
        <span className="item-list-main">
          <span className="item-list-title">{title}</span>
          {hint}
          {link != null && <span className="item-list-link">{link}</span>}
        </span>
        {trailing}
      </button>
    </li>
  );
}
